import { render, staticRenderFns } from "./RecommendationsPage.vue?vue&type=template&id=35fa72ad&scoped=true&"
import script from "./RecommendationsPage.vue?vue&type=script&lang=js&"
export * from "./RecommendationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa72ad",
  null
  
)

export default component.exports